import React from "react";

interface UsageIndicatorProps {
  percentage: number; // Pass the used percentage (e.g., 80 for 80%)
}

const UsageIndicator: React.FC<UsageIndicatorProps> = ({ percentage }) => {
  const radius = 45; // Radius of the semi-circle
  const strokeWidth = 10;
  const circumference = Math.PI * radius; // Half-circle circumference
  const progress = (percentage / 100) * circumference; // Convert percentage to stroke length

  return (
    <div className="relative w-[120px] h-[90px] flex items-center justify-center">
      <svg width="120" height="90" viewBox="0 0 120 60">
        {/* Background arc */}
        <path
          d="M10,50 A40,40 0 0,1 110,50"
          fill="none"
          stroke="#D3E3FD" // Light blue background
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        {/* Progress arc */}
        <path
          d="M10,50 A40,40 0 0,1 110,50"
          fill="none"
          stroke="#0469C5" // Blue progress color
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
        />
      </svg>

      {/* Centered text */}
      <div className="absolute mt-6 flex flex-col items-center">
        <p className="text-gray-500 text-sm">used</p>
        <p className="text-black text-lg font-bold">{percentage}%</p>
      </div>
    </div>
  );
};

export default UsageIndicator;
